import { fileCollectionToZip } from './fileCollectionToZip';
export class FileCollection {
    constructor(files) {
        this.files = files;
    }
    filter(callback) {
        return new FileCollection(this.files.filter(callback));
    }
    /**
     * Zip the FileCollection
     * This method returns a new FileCollection that contains only one FileItem that
     * is the zipped file (called by default 'file.zip')
     * Not sure this is super useful and we should probably remove it and replace it by fileCollectionToZip
     */
    async zip() {
        return fileCollectionToZip(this);
    }
    addText(relativePath, text, options = {}) {
        this.files.push(getItemFromText(relativePath, text, options));
    }
    addArrayBuffer(relativePath, arrayBuffer, options = {}) {
        this.files.push(getItemFromArrayBuffer(relativePath, arrayBuffer, options));
    }
    addTypedArray(relativePath, typedArray, options = {}) {
        this.files.push(getItemFromTypedArray(relativePath, typedArray, options));
    }
    [Symbol.iterator]() {
        return this.files.values();
    }
}
function getItemFromText(relativePath, text, options = {}) {
    const encoder = new TextEncoder();
    const data = encoder.encode(text);
    return {
        relativePath,
        name: relativePath.split('/').pop(),
        lastModified: options.dateModified || Date.now(),
        size: data.length,
        text: async () => {
            return text;
        },
        arrayBuffer: async () => {
            return data.buffer;
        },
        stream: () => {
            throw new Error('stream no implemented');
        },
    };
}
function getItemFromArrayBuffer(relativePath, arrayBuffer, options = {}) {
    const decoder = new TextDecoder();
    const text = decoder.decode(arrayBuffer);
    return {
        relativePath,
        name: relativePath.split('/').pop(),
        lastModified: options.dateModified || Date.now(),
        size: arrayBuffer.byteLength,
        text: async () => {
            return text;
        },
        arrayBuffer: async () => {
            return arrayBuffer;
        },
        stream: () => {
            throw new Error('stream no implemented');
        },
    };
}
function getItemFromTypedArray(relativePath, typedArray, options = {}) {
    return getItemFromArrayBuffer(relativePath, typedArray.buffer, options);
}
//# sourceMappingURL=FileCollection.js.map